"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Read a file object and invoke a callback function with the data url of this file
 * @param file The file to read
 * @param callback the callback to invoke with data url of the file.
 * If fail to read, dataUrl will be null
 */
function readFile(file, callback) {
    if (file) {
        var reader_1 = new FileReader();
        reader_1.onload = function () {
            callback(reader_1.result);
        };
        reader_1.onerror = function () {
            callback(null);
        };
        reader_1.readAsDataURL(file);
    }
}
exports.default = readFile;
//# sourceMappingURL=readFile.js.map